import React from 'react';
import { ArrowUp16, ArrowsVertical16, ArrowDown16 } from '@carbon/icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { setAddMemberModelOpenStart, selectIsModalOpen } from 'redux/member';
import { debounce } from 'utilities/helper.util';
import { USERSROLE } from 'types';
import { currentUser } from 'redux/session/selectors';
import {
  DataTable,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableContainer,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  Pagination,
  Button
} from 'carbon-components-react';
import { Header } from 'redux/member/types';
import DisplayMemberRow from './DisplayMemberRow';
import { Add16 } from '@carbon/icons-react';
import EmptyStatePage from './EmptyState';

const PageSizes = [10, 20, 50];

interface Props {
  responseMembers: Array<any> | null;
  pageInfo: any;
  setApiError: any;
  handleChangeSearchBy: any;
  sortOrder: any;
  setSortOrder: any;
  params: any;
}
const ShowSortOrder: React.FC<any> = ({
  colName,
  sortOrder,
  setSortOrder
}): any => {
  const handleSortOrder = () => {
    setSortOrder({
      sortedBy: colName,
      sortedOrder: sortOrder.sortedOrder === 'A' ? 'D' : 'A'
    });
  };
  return (
    <div onClick={handleSortOrder}>
      {colName !== sortOrder.sortedBy ? (
        <ArrowsVertical16 />
      ) : sortOrder.sortedOrder === 'A' ? (
        <ArrowUp16 />
      ) : (
        <ArrowDown16 />
      )}
    </div>
  );
};
const DisplayMembers: React.FC<Props> = ({
  responseMembers,
  pageInfo,
  setApiError,
  handleChangeSearchBy,
  sortOrder,
  setSortOrder,
  params
}) => {
  const dispatch: any = useDispatch();

  const isModalOpen: boolean = useSelector(selectIsModalOpen);

  const headers: Array<Header> = [
    {
      key: 'name',
      header: 'Name'
    },
    { key: 'utilityId', header: 'utility ID' },
    { key: 'organisationType', header: 'organisation Type' },
    { key: 'isDisabled', header: 'organisation is disabled' },
    { key: 'tenant', header: 'tenant' }
  ];
  const handleAddAssetOwner = () => {
    dispatch(setAddMemberModelOpenStart(true));
  };

  const handleApplySearch = (e: any) => {
    if (e.target.value.length > 2)
      debounce(handleChangeSearchBy, 300)(e.target.value);
    if (e.target.value.length === 2) debounce(handleChangeSearchBy, 300)(null);
  };
  const loggedUser = useSelector(currentUser);

  return (
    <>
      <DataTable rows={responseMembers || []} headers={headers}>
        {({ rows, getTableProps, getHeaderProps, getRowProps }: any) => {
          return (
            <TableContainer>
              <TableToolbar>
                <TableToolbarContent>
                  <TableToolbarSearch
                    onChange={handleApplySearch}
                    tabIndex={isModalOpen ? -1 : 0}
                  />
                  <Button
                    onClick={handleAddAssetOwner}
                    renderIcon={Add16}
                    iconDescription="Create asset owner"
                    disabled={loggedUser.role !== USERSROLE.DBYDADMIN}
                  >
                    Create asset owner
                  </Button>
                </TableToolbarContent>
              </TableToolbar>
              <Table {...getTableProps()}>
                <TableHead>
                  <TableRow>
                    <TableHeader />
                    <TableHeader
                      key="name"
                      {...getHeaderProps({ key: 'name', header: 'Name' })}
                    >
                      <div className="add-member-sort-header">
                        <div>Name</div>
                        <ShowSortOrder
                          colName="name"
                          sortOrder={sortOrder}
                          setSortOrder={setSortOrder}
                        />
                      </div>
                    </TableHeader>
                    <TableHeader
                      key="utilityId"
                      {...getHeaderProps({
                        key: 'utilityId',
                        header: 'utility ID'
                      })}
                    >
                      <div className="add-member-sort-header">
                        <div>Utility ID</div>
                      </div>
                    </TableHeader>
                    <TableHeader
                      key="tenant"
                      {...getHeaderProps({
                        key: 'tenant',
                        header: 'tenant'
                      })}
                    >
                      <div className="add-member-sort-header">
                        <div>Territory</div>
                      </div>
                    </TableHeader>
                    <TableHeader />
                    <TableHeader />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row: any, index: any) => (
                    <DisplayMemberRow
                      row={row}
                      getRowProps={getRowProps}
                      key={index}
                      setApiError={setApiError}
                      params={params}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          );
        }}
      </DataTable>

      {responseMembers && responseMembers?.length < 1 && <EmptyStatePage />}
      {responseMembers && responseMembers?.length > 1 && (
        <Pagination
          onChange={pageInfo.handleFetchNextPage}
          backwardText="Previous page"
          forwardText="Next page"
          itemsPerPageText="Items per page:"
          page={pageInfo.currentPage}
          pageNumberText="Page Number"
          pageSize={pageInfo.pageSize}
          pageSizes={PageSizes}
          totalItems={pageInfo.totalItems}
        />
      )}
    </>
  );
};
DisplayMembers.displayName = 'DisplayMembers';
export default DisplayMembers;
